import React from "react";
import "./style.css";

const InternetSignal = ({ signalStrength }) => {
  console.log(signalStrength,"Hey watch me 🛜"
  )
  // Map the signalStrength prop to the number of bars
  const getSignalBars = () => {
    // if (signalStrength >= 5) return 5;
    if (signalStrength > 15) return 4;
    if (signalStrength >= 5 && signalStrength <=15) return 3;
    if (signalStrength <=5) return 1;
    return 1;
  };

  const bars = getSignalBars();

  return (
    <div className="triangle-container">
      <div className={`bar bar-1 ${bars === 1? "low-inter" :bars >= 1 ? "active" : ""}`}></div>
      <div className={`bar bar-2 ${bars === 1? "low-inter" :bars >= 2 ? "active" : ""}`}></div>
      <div className={`bar bar-3 ${bars === 1? "low-inter" : bars >= 3 ? "active" : ""}`}></div>
      <div className={`bar bar-4 ${bars >= 4 ? "active" : ""}`}></div>
      {/* <div className={`bar bar-5 ${bars >= 5 ? "active" : ""}`}></div> */}
    </div>
  );
};

export default InternetSignal;
